import { upload } from "@testing-library/user-event/dist/upload";
import { residentialConstant } from "constants/payload/userWorkflowConstant"
import { useSelector } from "react-redux";
import { calculateGrade } from "./calculateNetAsset";
import moment from "moment";

const toCamelCase =(value) =>{
    value = value?.toLowerCase()
    let arrData = value?.split(" ")
    let finalValue =''
    arrData?.map((item)=>{
        if(item){
        finalValue = finalValue + item[0]?.toUpperCase() + item?.slice(1) + ' '
        }
    })
    finalValue = finalValue?.slice(0,-1)
    return finalValue
}

export const createMasterDataPayload = (
  dynamic_wf,
  data,
  organisation_id,
  configurationId,
  saveData = [],
  isEmailVerified,
  isMobileVerified,
  fieldName,
  email,
  recursiveFormData,
  order,
  dynamicConfigId,
  application_ref_id,
  createdUserId,
  applicant_sequence,
  loggedInUserName,
  loggedInUserEmail,
  loggedInUserMobileNumber,
  recursiveData,
  id,
  trigger,
  userInitatedRequired,
  formattedData,
  verification,
  user_hierarchy
  
  
) => {
  let verify = false,
    is_consent_approved = false,
    created_by = null
  if (userInitatedRequired) {
      data.informer_role_id = id;
      data.informer_trigger= trigger
  if (createdUserId)
      created_by = createdUserId || null;
    if (loggedInUserName && !user_hierarchy) {
      data.internal_poc_name = loggedInUserName;
      data.internal_poc_user_id = createdUserId;
      data.internal_poc_email_id = loggedInUserEmail;
      data.internal_poc_mobile_number = loggedInUserMobileNumber; 
    }
  } else {
    created_by = null;
  }
  // for only email verification need to change after whatsapp otp
  // if (isEmailVerified && isMobileVerified) {
  //     verify = true;
  // }
  if (isEmailVerified) {
    verify = true;
  }
  let applicantObj = {},
    finalPayload = {};

  applicantObj = {
    created_at: new Date(),
    is_active: true,
    is_deleted: false,
    is_verified: verify,
    is_consent_approved: false,
    active_step:  1,
  };

  if (data?.hasOwnProperty("privacy")) applicantObj.is_consent_approved = true;

  if (saveData && saveData?.length) {
    // applicantFields.map(element => {
    //     delete data[element]
    // })

    let saveData1 = saveData?.map((item, index) => {
      let title = item?.other_title ? item?.other_title : item?.title;
      let salutation = "";
      if (item?.title == "Mr.") {
        salutation = "Sir";
      } else if (item?.title == "Mrs." || item?.title == "Ms.") {
        salutation = "Madam";
      } else {
        salutation = "Sir/Madam";
      }
      let agreementDate = moment().format("MMMM Do of YYYY");
      let applicantName = item?.full_name ? toCamelCase(item?.full_name) : "";
      let firstName = item?.first_name ? toCamelCase(item?.first_name) : "";
      let middleName = item?.middle_name ? toCamelCase(item?.middle_name) : "";
      let lastName = item?.last_name ? toCamelCase(item?.last_name) : "";
      if(firstName == "" && applicantName != ""){
        firstName = applicantName
      }
      item?.hasOwnProperty("first_name")
        ? (item = { ...item, first_name: firstName })
        : (firstName = "");
      item?.hasOwnProperty("middle_name")
        ? (item = { ...item, middle_name: middleName })
        : (middleName = "");
      item?.hasOwnProperty("last_name")
        ? (item = { ...item, last_name: lastName })
        : (lastName = "");
      firstName = firstName?.length > 0 ? " " + item?.first_name : firstName;
      middleName =
        middleName?.length > 0 ? " " + item?.middle_name : middleName;
      lastName = lastName?.length > 0 ? " " + item?.last_name : lastName;
      // let fullName = title + firstName + middleName + lastName;

      let fullName = applicantName != "" ? (title|| "") + " " + applicantName :  (title|| "") + (firstName||"") + (middleName||"") + (lastName||"");
      let isResidenceIndia = item?.residence_country
        ? item?.residence_country == "India"
          ? "Resident Indian"
          : "Non- Resident Indian"
        : "Non- Resident Indian";
      if (index == 0) {
        return {
          ...item,
          // case changes to be made on the backend
          workflow_type: "primary",
          // is_consent_approved: true,
          // status: "Verification Pending",
          status:verification !== undefined ? (verification ? "In draft" : "Verification Pending") : "In draft",
          is_verified: false,
          active_step: 1,
          full_name: fullName,
          first_name : firstName == "" && applicantName != "" ? applicantName : firstName,
          ResidenceIndia: isResidenceIndia,
          salutation: salutation,
          agreementDate: agreementDate,
          // "source_data":{
          //   "internal_poc_name" :loggedInUserName,
          //   "internal_poc_user_id" : createdUserId,
          //   "internal_poc_email" :loggedInUserEmail,
          //   "internal_poc_mobile_number" : loggedInUserMobileNumber
          // }
        };
      } else if (index != 0) {
        if (item.hasOwnProperty("guardian_of")) {
          return {
            ...item,
            workflow_type: "guardian",
            // is_consent_approved: true,
            status: "Verification Pending",
            is_verified: false,
            active_step: 1,
            full_name: fullName,
            first_name : firstName == "" && applicantName != "" ? applicantName : firstName,
            ResidenceIndia: isResidenceIndia,
            salutation: salutation,
            agreementDate: agreementDate,
          };
        } else {
          return {
            ...item,
            workflow_type: "co-applicant",
            // is_consent_approved: true,
            status: "Verification Pending",
            is_verified: false,
            active_step: 1,
            full_name: fullName,
            first_name : firstName == "" && applicantName != "" ? applicantName : firstName,
            ResidenceIndia: isResidenceIndia,
            salutation: salutation,
            agreementDate: agreementDate,
          };
        }
      }

      if (item.email == email) {
        return {
          ...item,
          is_verified: verify,
        };
      }

      return { ...item, is_consent_approved: false };
    });
    finalPayload = {
      configuration_id: configurationId,
      organisation_id: organisation_id,
      dynamic_config_id: dynamicConfigId,
      created_at: new Date(),
      is_active: true,
      dynamic_wf : dynamic_wf,
      is_deleted: false,
      application_ref_id: application_ref_id,
      created_by: created_by,
      source_data: dynamic_wf ? { ...data, ...recursiveData, ...formattedData} : {...data, ...formattedData},
      // source_data: { ...data },
    };
    finalPayload.source_data["subworkflows"] = saveData1;

    if (data?.hasOwnProperty("_id") || data?.hasOwnProperty("configuration_id")) {
      delete finalPayload.source_data["_id"];
      delete finalPayload.source_data["configuration_id"];
    }
  } else {
    recursiveFormData &&
      Object.entries(recursiveFormData).map((item) => {
        applicantObj[item[0]] = item[1];
      });

    finalPayload = {
      configuration_id: configurationId,
      organisation_id: organisation_id,
      dynamic_config_id: dynamicConfigId,
      dynamic_wf : dynamic_wf,
      created_at: new Date(),
      is_active: true,
      is_deleted: false,
      application_ref_id: application_ref_id,
      created_by: created_by,
      source_data: dynamic_wf ? { ...data, ...recursiveData, ...formattedData} : {...data, ...formattedData},
    };
    finalPayload.source_data["subworkflows"] = [applicantObj];
  }
  // console.log(finalPayload);
  if (applicant_sequence?.required) {
    finalPayload.applicant_sequence = { ...applicant_sequence };
  }
  finalPayload.initiationMode = loggedInUserName ? 'user' : 'customer'
  return finalPayload;
};

export const createUserWorkflowPayload = (data, recursiveData, uploadedDocument, selectedQuestion, questionData, questionnaireId, isSignerRecursion, signerData,documents,deleteDocument,evaluationRule,isRecursiveData,declarationobjects) => {
    let total = 0;
    for (let x in selectedQuestion) {
        total = total + (+selectedQuestion[x]);
    }
    for (let Question in selectedQuestion) {
        delete data[Question]
    }
    //residentialConstant.map((item, index) => {
    //     const { children } = item
    //     if (children.length) {
    //         let keyObj = {}
    //         children.map((_item, _index) => {
    //             if (data.hasOwnProperty(_item.key))
    //                 keyObj[_item.key] = data[_item.key]
    //         })
    //         finalObj[item.key] = keyObj
    //     } else {
    //         if (data.hasOwnProperty(item.key)){
    //             finalObj[item.key] = data[item.key]
    //             delete data[item.key]
    //         }
    //     }
    // })

    // if(uploadedDocument && Object.keys(uploadedDocument).length){
    //     Object.keys(data).forEach((key)=>{
    //         Object.keys(uploadedDocument).forEach((item)=>{
    //             if(key === item) delete(data[key])
    //         })
    //     })
    // }

    // risk_profile, risk_score
    // let riskProfile = Object.keys(selectedQuestion).length ? { risk_profile :Category} : null;
    if (data?.updated_history) delete data?.updated_history
    if(data?.verification_response) delete data?.verification_response
    let riskScore
    let gradeValue
    if (selectedQuestion)
        riskScore = Object.keys(selectedQuestion).length ? { score: total } : null;

    if(selectedQuestion && Object.keys(selectedQuestion)?.length && evaluationRule){
        gradeValue = calculateGrade(total,evaluationRule)
    }
    let questionObject = {}
    questionObject[questionnaireId] = questionData
    // let questions = Object.keys(selectedQuestion).length ? { ...selectedQuestion } : null;
    let risk_profiling = questionData.length ? questionObject : null
    // let newSourceData;
    // if (isSignerRecursion){
    //     newSourceData = {
    //         source_data: { ...data, ...recursiveData, ...riskScore, ...risk_profiling },
    //         uploadedDocument: { ...uploadedDocument },
    //         signer_info : [...signerData],
    //         last_updated_at: new Date(),
    //     }
    // }
    // else {
    //     newSourceData = {
    //         source_data: { ...data, ...recursiveData, ...riskScore, ...risk_profiling },
    //         uploadedDocument: { ...uploadedDocument },
    //         last_updated_at: new Date(),
    //     }
    // }
    const newSourceData = {
        source_data: { ...data, ...recursiveData, ...riskScore, ...gradeValue, ...risk_profiling },
        uploadedDocument: { ...uploadedDocument },
        documents:{...documents},
        last_updated_at: new Date(),
        deleteDocument:deleteDocument ? [...deleteDocument] : [],
        isRecursiveData : isRecursiveData
    }
    if(declarationobjects) {
      newSourceData["declarations"] = declarationobjects;
    }
    // from newSourceData.source_data remove key where key name is ""
    Object.keys(newSourceData.source_data).forEach((key) => {
        if (key === "") {
            delete newSourceData.source_data[key]
        }
    })

 // remove updateRequested array from source_data
    if (newSourceData.source_data.hasOwnProperty("updateRequested")) {
        delete newSourceData.source_data.updateRequested
    }

    //delete isRMFlow from source_data and outside source_data
    //Changed Key isRMFlow to user_initiated_flow
    if (newSourceData.source_data.hasOwnProperty("user_initiated_flow")) {
        delete newSourceData.source_data.user_initiated_flow
    }
    if (newSourceData.hasOwnProperty("user_initiated_flow")) {
        delete newSourceData.user_initiated_flow 
    } 



    if (isSignerRecursion){
      let newarr=[]
      newarr.push(newSourceData.source_data.signers_info[0])
      if(signerData?.length > 0){
        signerData.forEach((item) =>{
          if(newSourceData.source_data[item]){
            let sign_data = newSourceData.source_data[item]
            sign_data.forEach((ele)=>{
              newarr.push(ele)
            })
          }
        })
      }
      newSourceData.source_data['signers_info'] = [...newarr]
    }
    return newSourceData
}